import { useEffect, useState } from "react";
import { ArrowRight, Trophy, Lock } from "lucide-react";
import api from "@/lib/api";
import LevelBadge from "@/components/LevelBadge";

const JOURNEY = ["pawn", "knight", "bishop", "rook", "queen", "king"];
const NAMES = { pawn: "Peão", knight: "Cavalo", bishop: "Bispo", rook: "Torre", queen: "Dama", king: "Rei" };

export default function Progress() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/me/progress").then(({ data }) => setData(data)).catch(() => {}); }, []);
  if (!data) return <div className="p-8"><div className="h-8 w-48 bg-chessup-card rounded animate-pulse" /></div>;

  const currentIdx = JOURNEY.indexOf(data.level_key);

  return (
    <div className="p-5 sm:p-8 max-w-5xl mx-auto">
      <h1 className="font-heading text-3xl text-chessup-text mb-6">Meu Progresso</h1>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
        {[
          { label: "XP total", value: data.total_xp },
          { label: "Aulas concluídas", value: data.lessons_completed },
          { label: "Puzzles resolvidos", value: data.puzzles_solved },
          { label: "Precisão", value: `${data.accuracy}%` },
        ].map((s) => (
          <div key={s.label} className="rounded-xl border border-chessup-border bg-chessup-card p-4">
            <div className="text-2xl font-bold text-chessup-text">{s.value}</div>
            <div className="text-xs text-chessup-subtext mt-0.5">{s.label}</div>
          </div>
        ))}
      </div>

      <div className="rounded-2xl border border-chessup-border bg-chessup-deep/40 p-6 mb-8">
        <h2 className="font-heading text-xl text-chessup-text mb-6">Sua jornada</h2>
        <div className="flex flex-wrap items-center gap-3 sm:gap-5">
          {JOURNEY.map((k, i) => {
            const state = i < currentIdx ? "concluido" : i === currentIdx ? "atual" : "bloqueado";
            return (
              <div key={k} className="flex items-center gap-3 sm:gap-5">
                <div className="flex flex-col items-center gap-2">
                  <LevelBadge levelKey={k} state={state} size={64} />
                  <span className="text-xs text-chessup-subtext">{NAMES[k]}</span>
                </div>
                {i < JOURNEY.length - 1 && <ArrowRight className="h-4 w-4 text-chessup-border" />}
              </div>
            );
          })}
        </div>
      </div>

      <div className="rounded-2xl border border-chessup-border bg-chessup-card p-6">
        <div className="flex items-center gap-2 mb-5"><Trophy className="h-5 w-5 text-chessup-goldlight" /><h2 className="font-heading text-xl text-chessup-text">Conquistas</h2></div>
        {data.achievements.every((a) => !a.unlocked) && <p className="text-sm text-chessup-subtext mb-4">Sua coleção começa com o primeiro lance.</p>}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {data.achievements.map((a) => (
            <div key={a.key} data-testid={`achievement-${a.key}`} className={`rounded-xl border p-4 ${a.unlocked ? "border-chessup-gold/40 bg-chessup-gold/8" : "border-chessup-border bg-chessup-deep/40 opacity-60"}`}>
              <div className="flex items-center gap-2 mb-1">
                {a.unlocked ? <Trophy className="h-4 w-4 text-chessup-goldlight" /> : <Lock className="h-4 w-4 text-chessup-subtext" />}
                <span className={`text-sm font-semibold ${a.unlocked ? "text-chessup-goldlight" : "text-chessup-subtext"}`}>{a.title}</span>
              </div>
              <p className="text-xs text-chessup-subtext">{a.description}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
